import _ from 'lodash';
import createjs from 'createjs-collection';
import Color from 'color';

import * as fJS from './../cjsRoot/fJS';
import { cjsItem } from './../cjsRoot/cjsBase';
import { cjsPoint } from './../cjsObjects/cjsPoint';
import { cjsEffects } from './../cjsObjects/cjsEffects';

var blockMove = false;

export class cjsLine {
  _shape;
  _block;
  _start;
  _stop;
  _connect = {};
  _colors;
  _freeDrawing;
  _isCorrect;
  _correct;
  _cacheData;

  _effect;
  _speed;
  _wait;
  _waitStart;
  _autoHide;
  _time;
  _toVisible;
  _remove = false;

  constructor(obj) {
    // console.log(obj);
    this._connect = {
      itemA: obj.item,
      idPointA: obj.idPoint,
      itemB: false,
      idPointB: false,
    };
    // this._connect.idGroup = obj.idGroup;
    // this._connect.idItem = obj.idItem;
    // this._connect.idPoint = obj.idPoint;
    // this._connect.clone = obj.clone;

    this._freeDrawing =
      typeof obj.lines === 'object' && obj.lines !== null && typeof obj.lines.freeDrawing === 'boolean'
        ? obj.lines.freeDrawing
        : obj.stage.defConfig.lines.freeDrawing;
    this._block = false;
    this._isCorrect = -1;
    this._colors = _.cloneDeep(obj.stage.defConfig.lines);
    if (typeof obj.lines === 'object' && obj.lines !== null)
      this._colors = _.merge(_.cloneDeep(obj.stage.defConfig.lines), obj.lines);

    this._setLines('connect', obj);
    this._setLines('select', obj);
    this._setLines('good', obj);
    this._setLines('bad', obj);

    delete this._colors.freeDrawing;
    this._shape = new createjs.Shape();
    this._shape.name = 'line_' + this._shape.id;

    this._shape.listener = {
      md: this._shape.on('mousedown', this.stageMouseDown, null, false, {
        line: this,
        cjsStage: obj.stage,
      }),
      c: this._shape.on('click', this._stageMouseClick, null, false, {
        line: this,
        cjsStage: obj.stage,
      }),
    };

    this._start = typeof obj.start === 'object' && obj.start !== null ? obj.start : { x: 0, y: 0 };
    this._stop = typeof obj.stop === 'object' && obj.stop !== null ? obj.stop : { x: 0, y: 0 };

    this._speed =
      typeof obj.lines === 'object' && typeof obj.lines.hide === 'object' && fJS.isNumeric(obj.lines.hide.speed)
        ? obj.lines.hide.speed
        : obj.stage.defConfig.lines.hide.speed;
    this._wait =
      typeof obj.lines === 'object' && typeof obj.lines.hide === 'object' && fJS.isNumeric(obj.lines.hide.wait)
        ? obj.lines.hide.wait
        : obj.stage.defConfig.lines.hide.wait;
    this._effect =
      typeof obj.lines === 'object' &&
      typeof obj.lines.hide === 'object' &&
      typeof cjsEffects[obj.lines.hide.effect] === 'function'
        ? obj.lines.hide.effect
        : obj.stage.defConfig.lines.hide.effect;

    if (this.freeDrawing === true) {
      this._cacheData = {
        x: this._start.x,
        x2: this._stop.x,
        y: this._start.y,
        y2: this._stop.y,
        w: 0,
        h: 0,
        ls: this.color['select'].size,
      };
    }
  }

  _setLines(color, obj) {
    this._colors[color].size =
      typeof obj.lines === 'object' && typeof obj.lines[color] === 'object' && fJS.isNumeric(obj.lines[color].size)
        ? obj.lines[color].size
        : typeof obj.lines === 'object' && fJS.isNumeric(obj.lines.size)
        ? obj.lines.size
        : obj.stage.defConfig.lines[color].size;
    this._colors[color].hideLine =
      typeof obj.lines === 'object' &&
      typeof obj.lines[color] === 'object' &&
      typeof obj.lines[color].hideLine === 'boolean'
        ? obj.lines[color].hideLine
        : typeof obj.lines === 'object' && typeof obj.lines.hideLine === 'boolean'
        ? obj.lines.hideLine
        : obj.stage.defConfig.lines[color].hideLine;

    let shadow =
      typeof obj.lines === 'object' &&
      typeof obj.lines[color] === 'object' &&
      typeof obj.lines[color].shadow === 'object'
        ? true
        : typeof obj.lines === 'object' && typeof obj.lines.shadow === 'object'
        ? true
        : false;

    if (shadow !== false) {
      this._colors[color].shadow = new createjs.Shadow(
        typeof obj.lines === 'object' &&
        typeof obj.lines[color] === 'object' &&
        typeof obj.lines[color].shadow === 'object' &&
        typeof obj.lines[color].shadow.color != 'undefined'
          ? typeof obj.lines[color].shadow.color
          : typeof obj.lines === 'object' &&
            typeof obj.lines.shadow === 'object' &&
            typeof obj.lines.shadow.color != 'undefined'
          ? obj.lines.shadow.color
          : 'rgba(0,0,0,0.9)',
        typeof obj.lines === 'object' &&
        typeof obj.lines[color] === 'object' &&
        typeof obj.lines[color].shadow === 'object' &&
        fJS.isNumeric(obj.lines[color].shadow.offsetX)
          ? typeof obj.lines[color].shadow.offsetX
          : typeof obj.lines === 'object' &&
            typeof obj.lines.shadow === 'object' &&
            fJS.isNumeric(obj.lines.shadow.offsetX)
          ? obj.lines.shadow.offsetX
          : 0,
        typeof obj.lines === 'object' &&
        typeof obj.lines[color] === 'object' &&
        typeof obj.lines[color].shadow === 'object' &&
        fJS.isNumeric(obj.lines[color].shadow.offsetY)
          ? typeof obj.lines[color].shadow.offsetY
          : typeof obj.lines === 'object' &&
            typeof obj.lines.shadow === 'object' &&
            fJS.isNumeric(obj.lines.shadow.offsetY)
          ? obj.lines.shadow.offsetY
          : 0,
        typeof obj.lines === 'object' &&
        typeof obj.lines[color] === 'object' &&
        typeof obj.lines[color].shadow === 'object' &&
        fJS.isNumeric(obj.lines[color].shadow.blur)
          ? typeof obj.lines[color].shadow.blur
          : typeof obj.lines === 'object' &&
            typeof obj.lines.shadow === 'object' &&
            fJS.isNumeric(obj.lines.shadow.blur)
          ? obj.lines.shadow.blur
          : 0
      );
    }

    let gradient =
      typeof obj.lines === 'object' &&
      typeof obj.lines[color] === 'object' &&
      typeof obj.lines[color].gradient === 'object'
        ? obj.lines[color].gradient
        : typeof obj.lines === 'object' && typeof obj.lines[color] === 'object'
        ? obj.lines.gradient
        : false;

    if (gradient !== false) {
      this._colors[color].gradient = {};
      this._colors[color].gradient.colors =
        typeof obj.lines === 'object' &&
        typeof obj.lines[color] === 'object' &&
        typeof obj.lines[color].gradient === 'object' &&
        Array.isArray(obj.lines[color].gradient.colors)
          ? obj.lines[color].gradient.colors
          : typeof obj.lines === 'object' &&
            typeof obj.lines[color] === 'object' &&
            typeof obj.lines[color].gradient === 'object' &&
            Array.isArray(obj.lines[color].gradient.colors)
          ? obj.lines[color].gradient.colors
          : false;
      if (this._colors[color].gradient.colors === false || this._colors[color].gradient.colors.length < 2) {
        delete this._colors[color].gradient;
        return;
      }
      this._colors[color].gradient.ratios =
        typeof obj.lines === 'object' &&
        typeof obj.lines[color] === 'object' &&
        typeof obj.lines[color].gradient === 'object' &&
        Array.isArray(obj.lines[color].gradient.ratios)
          ? obj.lines[color].gradient.ratios
          : typeof obj.lines === 'object' &&
            typeof obj.lines[color] === 'object' &&
            typeof obj.lines[color].gradient === 'object' &&
            Array.isArray(obj.lines[color].gradient.ratios)
          ? obj.lines[color].gradient.ratios
          : false;
      if (
        this._colors[color].gradient.ratios === false ||
        this._colors[color].gradient.ratios.length < this._colors[color].gradient.colors.length
      ) {
        let ratios = [];
        ratios.push(0);
        if (this._colors[color].gradient.colors.length == 2) {
          ratios.push(1);
        } else if (this._colors[color].gradient.colors.length > 2) {
          let count = 1 / (this._colors[color].gradient.colors.length - 1);
          for (let i = 1; i <= this._colors[color].gradient.colors.length - 2; i++) {
            ratios.push(count * i);
          }
          ratios.push(1);
        }
        this._colors[color].gradient.ratios = ratios;
      }
    }
  }

  redraw(color, stage) {
    if (this.freeDrawing !== true) {
      this._shape.graphics.clear();
    }

    if (typeof this.color[color].gradient != 'undefined' && this.color[color].gradient != null) {
      this._shape.graphics.ls(
        this.color[color].gradient.colors,
        this.color[color].gradient.ratios,
        this._start.x,
        this._start.y,
        this._stop.x,
        this._stop.y
      );
    } else {
      this._shape.graphics.s(this.color[color].color);
    }
    this._shape.graphics
      .ss(this.color[color].size, 'round')
      .mt(this._start.x, this._start.y)
      .lt(this._stop.x, this._stop.y);

    if (this.color[color].shadow instanceof createjs.Shadow) {
      this._shape.shadow = this.color[color].shadow;
    }
    if (this.freeDrawing === true) {
      this._updateCacheData();
    }

    if (this._shape.cacheID > 0) {
      this._shape.updateCache();
    }

    let zIndx = stage._stage.getChildIndex(stage.groups[this.connect.itemA.idGroup].container),
      zIndx2 =
        typeof this.connect.itemB.idGroup === 'string'
          ? stage._stage.getChildIndex(stage.groups[this.connect.itemB.idGroup].container)
          : -1;
    if (zIndx2 === -1) return;

    if (this.color[color].hideLine === true) {
      stage._stage.setChildIndex(this._shape, 0);
    } else {
      stage._stage.setChildIndex(this._shape, zIndx2 > zIndx ? zIndx2 : zIndx);
    }
  }

  redrawFree(color, stage) {
    let c = new Color(this.color[color].color);
    this._shape.filters = [new createjs.ColorFilter(0, 0, 0, 1, c.red(), c.green(), c.blue(), 1)];
    this._shape.cache(
      this._cacheData.x - this._cacheData.ls,
      this._cacheData.y - this._cacheData.ls,
      this._cacheData.w,
      this._cacheData.h
    );

    let zIndx = stage._stage.getChildIndex(stage.groups[this.connect.itemA.idGroup].container),
      zIndx2 =
        typeof this.connect.itemB.idGroup === 'string'
          ? stage._stage.getChildIndex(stage.groups[this.connect.itemB.idGroup].container)
          : -1;
    if (zIndx2 === -1) return;

    if (this.color[color].hideLine === true) {
      stage._stage.setChildIndex(this._shape, zIndx2 < zIndx ? zIndx2 : zIndx);
    } else {
      stage._stage.setChildIndex(this._shape, zIndx2 > zIndx ? zIndx2 : zIndx);
    }
  }

  connectTo(point) {
    if (point === true)
      return {
        item: this.connect.itemB,
        idPoint: this.connect.idPointB,
      };
    return { item: this.connect.itemB };
  }

  connected(point) {
    if (point === true)
      return {
        item: this.connect.itemA,
        idPoint: this.connect.idPointA,
      };
    return { item: this.connect.itemA };
  }

  stageMouseDown(e, data) {
    console.log('cjsLine: DOWN');
    e.stopPropagation();
  }

  _stageMouseClick(e, data) {
    console.log('cjsLine: CLICK');
    let line = data.line,
      stage = data.cjsStage;

    console.log('A: ' + line.connect.itemA.idGroup + ' - ' + line.connect.itemA.idc);
    console.log('B: ' + line.connect.itemB.idGroup + ' - ' + line.connect.itemB.idc);

    stage.groups[line.connect.itemA.idGroup].items[line.connect.itemA.idc]._removeLine(line.id);
    stage.groups[line.connect.itemA.idGroup].items[line.connect.itemA.idc].checkPoints();

    stage.mousedown = false;
    stage.groups[line.connect.itemA.idGroup].items[line.connect.itemA.idc]._mousedown = false;
    e.stopPropagation();
  }

  _updateCacheData() {
    if (this._cacheData.x > this._stop.x) this._cacheData.x = this._stop.x;
    if (this._cacheData.x2 < this._stop.x) this._cacheData.x2 = this._stop.x;
    if (this._cacheData.y > this._stop.y) this._cacheData.y = this._stop.y;
    if (this._cacheData.y2 < this._stop.y) this._cacheData.y2 = this._stop.y;

    if (this._cacheData.y2 > this._cacheData.y) this._cacheData.h = this._cacheData.y2 - this._cacheData.y;
    else if (this._cacheData.y2 < this._cacheData.y) this._cacheData.h = this._cacheData.y - this._cacheData.y2;
    else this._cacheData.h = this._cacheData.y;

    this._cacheData.h += this._cacheData.ls * 2;

    if (this._cacheData.x2 > this._cacheData.x) this._cacheData.w = this._cacheData.x2 - this._cacheData.x;
    else if (this._cacheData.x2 < this._cacheData.x) this._cacheData.w = this._cacheData.x - this._cacheData.x2;
    else this._cacheData.w = this._cacheData.x;

    this._cacheData.w += this._cacheData.ls * 2;
  }

  get shape() {
    return this._shape;
  }
  set shape(v) {
    this._shape = v;
  }
  get block() {
    return this._block;
  }
  set block(v) {
    this._block = v;
  }
  set stop(v) {
    this._stop = v;
  }
  set start(v) {
    this._start = v;
  }
  get connect() {
    return this._connect;
  }
  set connect(v) {
    this._connect = v;
  }
  get isCorrect() {
    return this._isCorrect;
  }
  set isCorrect(v) {
    this._isCorrect = v;
  }

  get correct() {
    return this._correct;
  }
  set correct(v) {
    this._correct = v;
  }

  get color() {
    return this._colors;
  }
  get freeDrawing() {
    return this._freeDrawing;
  }
  get id() {
    return this._shape.id;
  }

  set remove(v) {
    this._remove = v;
  }
  get remove() {
    return this._remove;
  }

  setTime() {
    this._time = new Date();
  }

  get visible() {
    return this._container.visible;
  }
  set visible(v) {
    if (typeof this._effect !== 'string') this._container.visible = v;
    else {
      this._toVisible = v;
      this.setTime();
    }
  }

  get toVisible() {
    return this._toVisible;
  }
  set toVisible(v) {
    this._toVisible = v;
  }

  get effect() {
    return this._effect;
  }
  get speed() {
    return this._speed;
  }
  get wait() {
    return this._wait;
  }
  set wait(v) {
    this._wait = v;
  }
  get waitStart() {
    return this._waitStart;
  }
  get autoHide() {
    return this._autoHide;
  }
  get time() {
    return this._time;
  }
}
